module.exports = __webpack_public_path__ + "media/IntoBattlePP.eb490b70.mp3";